// document.addEventListener("variant:change", (event) => {
//   const variant = event.detail.variant;
//   const discount = parseFloat(window.themeSettings?.global_discount || 0);

//   console.log("🟦 ICON VARIANT CHANGE");
//   console.log("▶ variant.price:", variant.price);
//   console.log("▶ discount:", discount);

//   // Si no hay descuento global, devolver precio normal
//   if (!discount || discount <= 0) {
//     document.querySelector(".price--compare")?.classList.add("hidden");
//     document.querySelector(".saved--amount")?.classList.add("hidden");

//     document.querySelector(".price--discounted").textContent =
//       formatMoneyNoSymbol(variant.price);
//     return;
//   }

//   const multiplier = (100 - discount) / 100;
//   const discountedPrice = Math.round(variant.price * multiplier);
//   const saved = variant.price - discountedPrice;

//   console.log("▶ multiplier:", multiplier);
//   console.log("▶ discountedPrice:", discountedPrice);

//   document.querySelector(".price--compare").textContent =
//     formatMoneyNoSymbol(variant.price);

//   document.querySelector(".price--discounted").textContent =
//     formatMoneyNoSymbol(discountedPrice);

//   document.querySelector(".saved--amount").textContent =
//     `(Save ${formatMoneyNoSymbol(saved)})`;
// });



document.addEventListener('DOMContentLoaded', function() {
    // Función para actualizar la miniatura seleccionada
    function updateSelectedThumbnail(clickedTitle = null) {
        // Si tenemos un título clickeado, mostrarlo inmediatamente
        if (clickedTitle) {
            console.log('🖼️ Clicked variant:', clickedTitle);
        }
        
        // También encontrar y mostrar la variante actualmente seleccionada
        setTimeout(() => {
            const selectedLabel = document.querySelector('.variant-picker__option-values input:checked + label');
            if (selectedLabel) {
                const selectedTitle = selectedLabel.title || selectedLabel.textContent.trim();
                // console.log('✅ Currently selected:', selectedTitle);
                
                // Actualizar el botón de navegación correspondiente
                updateGalleryNavigationButton(selectedTitle);
            } else {
                // console.log('⚠️ No variant selected');
            }
        }, 50);
    }

    // Nueva función para actualizar el botón de navegación de la galería
    function updateGalleryNavigationButton(variantTitle) {
        // Buscar todos los botones dentro de product-gallery-navigation
        const navigationButtons = document.querySelectorAll('product-gallery-navigation button[data-variant]');
        
        if (navigationButtons.length === 0) {
            // console.log('⚠️ No gallery navigation buttons found');
            return;
        }

        // console.log('🔄 Updating gallery navigation for variant:', variantTitle);

        // Primero, establecer todos los botones a selected-variant="false"
        navigationButtons.forEach(button => {
            button.setAttribute('selected-variant', 'false');
        });

        // Buscar el botón que coincide con el título de la variante
        let buttonFound = false;
        navigationButtons.forEach(button => {
            const buttonVariant = button.getAttribute('data-variant');
            
            // Comparar el título de la variante con el data-variant
            // Normalizar ambos para comparación (eliminar espacios extras, pasar a minúsculas)
            const normalizedButtonVariant = buttonVariant?.trim().toLowerCase();
            const normalizedVariantTitle = variantTitle?.trim().toLowerCase();
            
            if (normalizedButtonVariant === normalizedVariantTitle) {
                button.setAttribute('selected-variant', 'true');
                buttonFound = true;
                // console.log('✅ Gallery button updated:', buttonVariant, '→ selected-variant="true"');
            }
        });

        if (!buttonFound) {
            // console.log('⚠️ No matching gallery button found for variant:', variantTitle);
            
            // Opcional: Intentar buscar por coincidencia parcial si es necesario
            navigationButtons.forEach(button => {
                const buttonVariant = button.getAttribute('data-variant');
                if (variantTitle.toLowerCase().includes(buttonVariant.toLowerCase()) || 
                    buttonVariant.toLowerCase().includes(variantTitle.toLowerCase())) {
                    // console.log('🔍 Possible match found (partial):', buttonVariant);
                }
            });
        }
    }

    // Manejar cambios de variante (tu código existente mejorado)
    document.addEventListener("variant:change", (event) => {
        const variant = event.detail.variant;
        const discount = parseFloat(window.themeSettings?.global_discount || 0);

        // console.log("🟦 VARIANT CHANGE - PRICE UPDATE");
        // console.log("▶ Variant ID:", variant.id);
        // console.log("▶ Variant title:", variant.title);
        // console.log("▶ Original price:", variant.price);
        // console.log("▶ Discount %:", discount);

        // Actualizar la miniatura y el botón de navegación cuando cambia la variante
        updateSelectedThumbnail(variant.title);

        // Si no hay descuento global, mostrar precio normal
        if (!discount || discount <= 0) {
            document.querySelector(".price--compare")?.classList.add("hidden");
            document.querySelector(".saved--amount")?.classList.add("hidden");

            const priceElement = document.querySelector(".price--discounted");
            if (priceElement) {
                priceElement.textContent = formatMoneyNoSymbol(variant.price);
                console.log("▶ Final price (no discount):", variant.price);
            }
            return;
        }

        // Calcular precio con descuento
        const multiplier = (100 - discount) / 100;
        const discountedPrice = Math.round(variant.price * multiplier);
        const saved = variant.price - discountedPrice;

        // console.log("▶ Multiplier:", multiplier);
        // console.log("▶ Discounted price:", discountedPrice);
        // console.log("▶ You save:", saved);

        // Actualizar elementos del DOM
        const compareElement = document.querySelector(".price--compare");
        const discountedElement = document.querySelector(".price--discounted");
        const savedElement = document.querySelector(".saved--amount");

        if (compareElement) {
            compareElement.textContent = formatMoneyNoSymbol(variant.price);
            compareElement.classList.remove("hidden");
        }

        if (discountedElement) {
            discountedElement.textContent = formatMoneyNoSymbol(discountedPrice);
        }

        if (savedElement) {
            savedElement.textContent = `(Save ${formatMoneyNoSymbol(saved)})`;
            savedElement.classList.remove("hidden");
        }
    });

    // Event delegation para clicks en labels de variantes
    const container = document.querySelector('.variant-picker__option-values');
    if (container) {
        container.addEventListener('click', function(e) {
            const label = e.target.closest('label');
            if (label) {
                const clickedTitle = label.title || label.textContent.trim();
                
                // Mostrar que se hizo click en una variante
                // console.log('👆 Variant label clicked:', clickedTitle);
                
                // Actualizar miniatura con el título clickeado
                updateSelectedThumbnail(clickedTitle);
                
                // Nota: El evento "variant:change" se disparará automáticamente
                // cuando el input radio cambie, actualizando los precios
            }
        });

        // Mostrar selección inicial al cargar la página
        setTimeout(() => {
            const initialSelected = document.querySelector('.variant-picker__option-values input:checked + label');
            if (initialSelected) {
                const initialTitle = initialSelected.title || initialSelected.textContent.trim();
                // console.log('📦 Initial variant loaded:', initialTitle);
                
                // Actualizar la navegación de la galería con la variante inicial
                updateGalleryNavigationButton(initialTitle);
            }
        }, 100);
    } else {
        console.log('⚠️ Variant picker container not found');
    }
});

// Función auxiliar para formatear moneda (si no existe)
function formatMoneyNoSymbol(amount) {
    // Asumiendo que esta función ya existe en tu código
    // Si no existe, puedes implementarla así:
    if (typeof window.formatMoneyNoSymbol === 'function') {
        return window.formatMoneyNoSymbol(amount);
    }
    
    // Implementación básica de respaldo
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount / 100);
}